import { useEffect, useState } from "react";

type TokenTimerProps = {
  time: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};

export const TokenTimer = ({ time, setStep }: TokenTimerProps) => {
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);

  useEffect((): void => setMinutes(time), [time]);

  useEffect(() => {
    let intervalId = setInterval(() => {
      if (seconds === 0) {
        setSeconds(59);
        minutes - 1 > -1 ? setMinutes(minutes - 1) : setStep(2);
        minutes - 1 === -1 && clearInterval(intervalId);
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [seconds, minutes, setStep]);

  return (
    <div className="d-inline text title">
      <span>{minutes}</span>:
      <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
    </div>
  );
};
